import o from 'aos';
import './js/menu.js';
import './js/header.js';
import './js/modal.js';
o.init({ once: !0 });
